import { COLORS, stickyTopOffset } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  margin: 0 auto;
  padding: 50rem 0;
  max-width: 1440rem;
  width: 100%;

  ${respondTo.smallLaptop`
    padding: 50rem 15rem;
  `}

  ${respondTo.smallTablet`
    padding: 20rem 15rem;
  `}
`;

// The table's sticky header stacks below this row by its measured height. The
// negative margin cancels the top padding, which only gives the row breathing
// room below the app header once stuck.
export const Row = styled.div`
  position: sticky;
  top: ${stickyTopOffset};
  z-index: 3;
  justify-content: space-between;
  display: flex;
  width: 100%;
  margin-top: -20rem;
  padding: 20rem 0 25rem;
  background-color: ${COLORS.BACKGROUND};
`;

export const Heading = styled.h2`
  font-size: 40rem;
  font-weight: 300;
  color: ${COLORS.BLACK};

  ${respondTo.smallTablet`
    font-size: 30rem;
  `}
`;

export const FlexAlignCenterSpaceBetween = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;

  ${respondTo.smallTablet`
    align-items: flex-end;
    gap: 20rem;
  `}

  ${respondTo.bigPhone`
    flex-direction: column;
    gap: 20rem;
    align-items: flex-start;
  `}
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 30rem;

  ${respondTo.smallTablet`
    flex-direction: column;
    align-items: flex-start;
    gap: 10rem;
    width: 100%;
  `}
`;

export const InputWrapper = styled.div`
  width: 300rem;

  ${respondTo.smallTablet`
    width: 100%;
  `}
`;

export const AbsoluteWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 10rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  pointer-events: none;
  user-select: none;
`;
